import { render, staticRenderFns } from "./EditStoreInfo.vue?vue&type=template&id=5314b87d"
import script from "./EditStoreInfo.vue?vue&type=script&lang=js"
export * from "./EditStoreInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports